import { render, staticRenderFns } from "./OsCampaignOverview.vue?vue&type=template&id=819c9992&scoped=true"
import script from "./OsCampaignOverview.vue?vue&type=script&lang=ts"
export * from "./OsCampaignOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819c9992",
  null
  
)

export default component.exports